/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Wiz_SkipInputs */



/**
* | output |
* | --- |
* | "Skip the questions and fill in the form yourself" |
*
* @param {Tournament_Wiz_SkipInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_wiz_skip = /** @type {((inputs?: Tournament_Wiz_SkipInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Wiz_SkipInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Passer les questions et remplir le formulaire vous-même")
	if (locale === "es") return /** @type {LocalizedString} */ ("Omitir las preguntas y rellenar el formulario a mano")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Pular as perguntas e preencher o formulário por conta própria")
	if (locale === "it") return /** @type {LocalizedString} */ ("Salta le domande e compila il modulo da solo")
	return /** @type {LocalizedString} */ ("Skip the questions and fill in the form yourself")
});